/**
 * @interface
 * @param {jQuerySelector=} selector
 * @param {Object.<string,*>=} options
 */
Foundation.View.Interface.Spinner = function (selector, options) {};

Foundation.View.Interface.Spinner.prototype.show = function () {};

Foundation.View.Interface.Spinner.prototype.hide = function () {};

/* eslint no-unused-vars: "off" */
